"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const creatable_1 = __importDefault(require("react-select/creatable"));
const styles = {
    // eslint-disable-next-line complexity
    control: (base, state) => (Object.assign(Object.assign({}, base), { borderRadius: '.125rem', boxShadow: state.isFocused ? '0 0 0 0.1875rem rgba(54,124,43,.25)' : 0, borderColor: state.isFocused ? "#367c2b" : "#666666", '&:hover': {} })),
    dropdownIndicator: (base) => (Object.assign(Object.assign({}, base), { color: '#666', '&:hover': {
            color: '#000',
        } })),
    valueContainer: (base) => (Object.assign(Object.assign({}, base), { padding: '2px 8px', overflow: 'auto', maxHeight: '110px' })),
    menu: (base) => (Object.assign(Object.assign({}, base), { marginTop: '1px', 
        //width: 'auto',
        borderRadius: '.125rem' })),
    menuList: (base) => (Object.assign(Object.assign({}, base), { padding: '0px' })),
    option: (base, state) => (Object.assign(Object.assign({}, base), { whiteSpace: 'nowrap', padding: '4px 10px', color: state.isSelected ? 'white' : 'black', backgroundColor: state.isSelected ? '#367c2b' : 'white', ':hover': {
            backgroundColor: '#cddcc6',
            color: '#000',
        } })),
    noOptionsMessage: (base) => (Object.assign(Object.assign({}, base), { color: 'black', width: 'auto' })),
    multiValueRemove: (base) => (Object.assign(Object.assign({}, base), { color: '#367c2b', ':hover': {
            backgroundColor: '#367c2b',
            color: '#eee'
        } })),
    indicatorsContainer: (base) => (Object.assign(Object.assign({}, base), { verticalAlign: 'top', height: '100%' })),
    clearIndicator: (base) => (Object.assign(Object.assign({}, base), { ':hover': {
            backgroundColor: '#f6dbde',
            color: '#c21020',
        } }))
};
function Select(props) {
    if (props.creatable) {
        return (react_1.default.createElement(creatable_1.default, Object.assign({ options: props.options, styles: styles }, props)));
    }
    else {
        return (react_1.default.createElement(react_select_1.default, Object.assign({ options: props.options, styles: styles }, props)));
    }
}
exports.default = Select;
